import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const QUICK_LINKS = [
  { to: '/', label: 'Home', desc: 'Back to the homepage' },
  { to: '/events', label: 'Events', desc: 'Bonfire Night, GlossFest, Heritage Weekend' },
  { to: '/bonfire', label: 'Bonfire Night', desc: 'Join the 2026 launch list' },
  { to: '/membership', label: 'Membership', desc: 'Join Glossop Round Table' },
  { to: '/news', label: 'News', desc: 'Latest updates from the Round Table' },
  { to: '/round-table-bar', label: 'Round Table Bar', desc: 'Drinks, sponsors and the menu' },
];

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="min-h-[80vh] bg-[#0A0A0A] text-white">
      <SEO
        title="Are you lost?"
        description="Page not found — let's get you back on track."
        path="/404"
        noIndex
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <div className="border-l-4 border-[#F0A500] pl-6 mb-12">
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#F0A500] block mb-3">
            Error 404
          </span>
          <h1 className="text-5xl sm:text-7xl font-black uppercase tracking-tighter leading-none mb-6">
            Are you lost?
          </h1>
          <p className="text-base sm:text-lg text-zinc-300 max-w-2xl leading-relaxed">
            We can&rsquo;t find the page you&rsquo;re looking for &mdash; it may have moved, been renamed,
            or perhaps it never existed. The good news is, Glossop Round Table are a friendly bunch.
            Here are some places you might like to head instead:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {QUICK_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`not-found-link-${link.to.replace(/\//g, '') || 'home'}`}
              className="group block p-6 bg-zinc-950 border border-zinc-800 hover:border-[#F0A500] transition-colors"
            >
              <h2 className="text-lg font-bold mb-1 group-hover:text-[#F0A500] transition-colors">
                {link.label}
              </h2>
              <p className="text-sm text-zinc-400 leading-relaxed">{link.desc}</p>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-sm text-zinc-500">
          Still can&rsquo;t find what you need? Email us at{' '}
          <a href="mailto:info@glossoproundtable.org" className="text-[#F0A500] hover:underline">
            info@glossoproundtable.org
          </a>{' '}
          and we&rsquo;ll point you in the right direction.
        </div>
      </div>
    </div>
  );
}
